var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('type-input',_vm._b({staticClass:"required",attrs:{"value":_vm.value,"items":_vm.types},on:{"input":_vm.onTypeUpdate}},'type-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }